import React from 'react';
import { StoryCard } from '../StoryCard';

class SortablePollCard extends StoryCard {
	render() {
		return <div className="sortable-poll-card">{super.renderCard()}</div>;
	}
}

export default SortablePollCard;
